/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-ip-reputation-type-mapping';
const prefix = `${moduleName}.${componentName}`;

export const ipReputationMappingTitle = `${prefix}.ipReputationMappingTitle`;

export const ENGLISH = {
    [ipReputationMappingTitle]: 'IP Reputation Mapping',
};
